module.exports = __webpack_public_path__ + "static/media/postcodelec2017.0892fc78.geojson";